<ejs-dialog
  id="horizon-genesys-substitute-modal"
  #Dialog
  isModal="true"
  width="60%"
  [visible]="true"
  [allowDragging]="true"
  [header]="'call_log.call_log_temporal_substitute_view.title' | translate"
  [showCloseIcon]="true"
  (open)="onOpen($event)"
  (beforeClose)="onBeforeClose($event)"
  data-qa="genesys-temporal-substitute_modal"
>
  <div class="genesys-call-log-container">
    <form
      [formGroup]="form"
      class="genesys-call-log-container__form"
      (ngSubmit)="checkConversationIdIsValid()"
      data-qa="genesys-temporal-substitute_form"
    >
      <div>
        <label>
          {{
            "call_log.call_log_temporal_substitute_view.labels.call_id"
              | translate
          }}
          <horizon-tooltip
            isLabel="true"
            [tooltipContent]="callIdTooltipTemplateRef"
          ></horizon-tooltip>

          <ng-template #callIdTooltipTemplateRef>
            <span>
              {{
                "call_log.call_log_temporal_substitute_view.labels.call_id_tooltip"
                  | translate
              }}
            </span>
          </ng-template>
        </label>
        <horizon-text-input
          [control]="form.controls['callId']"
          (valueChange)="onCallIdChange($event)"
          data-qa="genesys-temporal-substitute_form_input_call-id"
        ></horizon-text-input>

        <div *ngIf="invalidCallId" class="invalid-error" data-qa="genesys-temporal-substitute_form_call-id_error">
          {{ "errors.GenesysNotFound" | translate }}
        </div>
      </div>
      <div>
        <horizon-text-input
          [control]="form.controls['phoneNumber']"
          [label]="
            'call_log.call_log_temporal_substitute_view.labels.phone_number'
          "
          (valueChange)="onPhoneNumberChange($event)"
          data-qa="genesys-temporal-substitute_form_input_phone-number"
        ></horizon-text-input>
        <div
          *ngIf="
            form.controls['phoneNumber'].touched &&
            !form.controls['phoneNumber'].valid
          "
          class="invalid-error"
          data-qa="genesys-temporal-substitute_form_phone-number_error"
        >
          {{ "errors.number_not_valid" | translate }}
        </div>
      </div>

      <horizon-dropdown
        [control]="form.controls['callType']"
        [label]="'call_log.call_log_temporal_substitute_view.labels.call_type'"
        [dropdownValues]="callTypeOptions"
        [fields]="callTypeOptionsValues"
        [showClearButton]="false"
        (valueSelected)="onCallTypeChange($event)"
        data-qa="genesys-temporal-substitute_form_dropdown_call-type"
      ></horizon-dropdown>

      <horizon-dropdown
        [control]="form.controls['callSubType']"
        [label]="
          'call_log.call_log_temporal_substitute_view.labels.call_sub_type'
        "
        [dropdownValues]="callSubTypeOptions"
        [fields]="callSubTypeOptionsValues"
        [enabled]="isSubTypeCodeEnabled"
        [showClearButton]="false"
        (valueSelected)="onCallSubTypeChange($event)"
        data-qa="genesys-temporal-substitute_form_dropdown_call-sub-type"
      ></horizon-dropdown>
    </form>
    <horizon-button
      #saveButton
      class="genesys-call-log-container__search-button"
      [text]="'call_log.call_log_temporal_substitute_view.labels.search'"
      [type]="'confirm'"
      [buttonColor]="globalSettings.colors.mainColor"
      [isDisabled]="form.invalid"
      (clickEvent)="checkConversationIdIsValid()"
    ></horizon-button>
  </div>
</ejs-dialog>
